import CheckboxGroupFieldSet from './CheckboxGroupFieldSet';

export default CheckboxGroupFieldSet;
